export const PAYMENT_DELIVERY_SECTIONS = [
    {
        id: "payment-information",
        titleKey: "pages.sellerProfile.paymentDelivery.sections.paymentInformation.title",
        hintKey: "pages.sellerProfile.paymentDelivery.sections.paymentInformation.hint",
        jumpKey: "pages.sellerProfile.paymentDelivery.sections.paymentInformation.jumpLabel",
        countsTowardCompleteness: true,
    },
    {
        id: "shipping-costs",
        titleKey: "pages.sellerProfile.paymentDelivery.sections.shippingCosts.title",
        hintKey: "pages.sellerProfile.paymentDelivery.sections.shippingCosts.hint",
        jumpKey: "pages.sellerProfile.paymentDelivery.sections.shippingCosts.jumpLabel",
        countsTowardCompleteness: true,
    },
    {
        id: "shipping-carriers",
        titleKey: "pages.sellerProfile.paymentDelivery.sections.shippingCarriers.title",
        hintKey: "pages.sellerProfile.paymentDelivery.sections.shippingCarriers.hint",
        jumpKey: "pages.sellerProfile.paymentDelivery.sections.shippingCarriers.jumpLabel",
        countsTowardCompleteness: true,
    },
    {
        id: "delivery-methods",
        titleKey: "pages.sellerProfile.paymentDelivery.sections.deliveryMethods.title",
        hintKey: "pages.sellerProfile.paymentDelivery.sections.deliveryMethods.hint",
        jumpKey: "pages.sellerProfile.paymentDelivery.sections.deliveryMethods.jumpLabel",
        countsTowardCompleteness: true,
    },
];
